export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10622.32f4f97d.jpg";